module.exports = __webpack_public_path__ + "static/vc-f226ca3fccbda88c6c226f5530d1aa49.svg";